import { SUITE } from "../../common/apiUrl/suite/suiteUrls";
import { generateCallbackCurlCommand, generateCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions";
import { AddClientJsonRequest, AddUserJsonRequest, ClientUploadCsvJsonRequest, EditClientJsonRequest } from "../../common/model/suite/jsonRequest";

const addClientJsonRequest: AddClientJsonRequest = {
    clientId: "string",
    defaultSignFirst: false,
    locationId: 0,
    clientDetails: {
        name: "string",
        emailAddress: "string",
        mobileNumber: "string",
        countryCode: "string",
        dob: "2024-12-02T12:14:42.374Z",
        ssn_or_ein: "string"
    },
    spouseDetails: {
        name: "string",
        emailAddress: "string",
        mobileNumber: "string",
        countryCode: "string",
        dob: "2024-12-02T12:14:42.374Z",
        ssn_or_ein: "string"
    },
    type: 0,
    ero: 0,
    mfj: false
}

const editClientJsonRequest: EditClientJsonRequest = {
    uniqueId: 0,
    clientId: "string",
    type: 0,
    ero: 0,
    mfj: false,
    defaultSignFirst: false,
    locationId: 0,
    clientDetails: {
        name: "string",
        emailAddress: "string",
        mobileNumber: "string",
        countryCode: "string",
        dob: "2024-12-02T12:14:42.374Z",
        ssn_or_ein: "string"
    },
    spouseDetails: {
        name: "string",
        emailAddress: "string",
        mobileNumber: "string",
        countryCode: "string",
        dob: "2024-12-02T12:14:42.374Z",
        ssn_or_ein: "string"
    }
}

const clientUploadCsvJsonRequest: ClientUploadCsvJsonRequest = {
    document: "string",
    fileName: "string",
    callbackUri: "string",
    correlationId: "string"
}

const addAndEditUserJsonRequest: AddUserJsonRequest = {
    firstName: "string",
    lastName: "string",
    emailAddress: "string",
    phone: "string",
    extension: "string",
    fax: "string",
    mobileNumber: "string",
    countryCode: "string",
    ptin: "string",
    userGroups: "string",
    officeLocations: "string",
    isMFAEnabled: false
}

export const addClientRequestCurl = generateCurlCommand(
    SUITE.CLIENT_MANAGEMENT.ADD_CLIENT_URL,
    "POST",
    addClientJsonRequest
)

export const getAllClientsJsonRequestCurl = generateNoBodyCurlCommand(
    SUITE.CLIENT_MANAGEMENT.ALL_CLIENTS_URL,
    "GET",
);

export const deleteClientJsonRequestCurl = generateNoBodyCurlCommand(
    SUITE.CLIENT_MANAGEMENT.DELETE_CLIENT_URL,
    "DEL",
);

export const editClientRequestCurl = generateCurlCommand(
    SUITE.CLIENT_MANAGEMENT.EDIT_CLIENT_URL,
    "PUT",
    editClientJsonRequest
)

export const ClientUploadCsvRequestCurl = generateCallbackCurlCommand(
    SUITE.CLIENT_MANAGEMENT.UPLOAD_CLIENT_CSV_URL,
    "POST",
    clientUploadCsvJsonRequest
)

/* OFFICE LOCATION */
export const getAllLocationsRequestCurl = generateNoBodyCurlCommand(
    SUITE.OFFICE_LOCATION.Get_ALL_LOCATION_URL,
    "GET"
)

export const locationByIdRequestCurl = generateNoBodyCurlCommand(
    SUITE.OFFICE_LOCATION.LOCATION_BY_ID_URL,
    "GET"
)

/* USER MANAGEMENT */
export const addUserRequestCurl = generateCurlCommand(
    SUITE.USER_MANAGEMENT.ADD_USER_URL,
    "POST",
    addAndEditUserJsonRequest
)

export const getAllUsersJsonRequestCurl = generateNoBodyCurlCommand(
    SUITE.USER_MANAGEMENT.GET_ALL_USERS_URL,
    "GET",
);

export const getAllUserGroupsRequestCurl = generateNoBodyCurlCommand(
    SUITE.USER_MANAGEMENT.GET_ALL_USER_GROUPS_URL,
    "GET"
)

export const editUserRequestCurl = generateCurlCommand(
    SUITE.USER_MANAGEMENT.EDIT_USER_URL,
    "PUT",
    { userId: 0, ...addAndEditUserJsonRequest }
)


export const deleteUserJsonRequestCurl = generateNoBodyCurlCommand(
    SUITE.USER_MANAGEMENT.DELETE_USER_URL,
    "DEL",
);